import DemoToastProvider from '@/components/feature/DemoToast';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import CollectionIndex from './components/CollectionIndex';
import FeedFlow from './components/FeedFlow';
import EvidenceSection from './components/EvidenceSection';
import ResourceSection from './components/ResourceSection';
import GallerySection from './components/GallerySection';
import UpdatesSection from './components/UpdatesSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <DemoToastProvider>
      <div className="min-h-screen w-full bg-background-50">
        <SiteHeader />
        <main className="w-full">
          <HeroSection />
          <CollectionIndex />
          <FeedFlow />
          <EvidenceSection />
          <ResourceSection />
          <GallerySection />
          <UpdatesSection />
        </main>
        <SiteFooter />
      </div>
    </DemoToastProvider>
  );
}